<template>
  <div class="helpy-tooltip-container align-top">
    <el-popover width="300" placement="top-start" trigger="hover">
      <div class="d-flex flex-column p-2">
        <div class="el-popover__title">{{ currentItem.title }}</div>
        <div class="helpy-tooltip--content" v-html="currentItem.content"></div>
        <div v-if="count > 1" class="d-flex justify-content-between mt-2">
          <div class="helpy_navigate">
            <el-button v-if="hasPrevious" @click="onPrevious" class="material-icons md-18"
              >keyboard_arrow_left
            </el-button>
          </div>
          <div>
            <span class="">{{ `${index + 1}/${count}` }}</span>
          </div>
          <div class="helpy_navigate">
            <el-button v-if="hasNext" @click="onNext" class="material-icons md-18">keyboard_arrow_right</el-button>
          </div>
        </div>
      </div>
      <el-button class="helpy-tooltip-button material-icons" slot="reference">question_mark</el-button>
    </el-popover>
  </div>
</template>
<script>
/**
 * @class Tooltip
 *
 * @description Tooltip component
 */
export default {
  name: 'Tooltip',
  props: {
    helpies: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      index: 0,
      count: this.helpies.length,
    }
  },
  computed: {
    hasNext() {
      return this.index + 1 < this.count
    },
    hasPrevious() {
      return this.index > 0
    },
    currentItem() {
      return this.helpies[this.index]
    },
  },
  methods: {
    onNext() {
      this.index++
    },
    onPrevious() {
      this.index--
    },
  },
}
</script>

<style lang="scss" scoped>
.helpy-tooltip-container {
  display: inline;
  position: absolute;
  top: -10px;
  right: -10px;
}
.checkbox .helpy-tooltip-container {
  top: 0;
  right: -20px;
}
.panel-heading .helpy-tooltip-container {
  top: 5px;
  right: 45px;
}
.sub-form-store .helpy-tooltip-container {
  top: 10px;
}
[data-schemaid='root'] .helpy-tooltip-container {
  top: 10px;
}
[data-schematype='array'] .helpy-tooltip-container {
  top: 15px;
  right: 30px;
}
.helpy-tooltip-button {
  padding: 0px !important;
  margin-left: 5px;
  background-color: $color-primary;
  color: $color-text-light;
  border-radius: 50%;
  padding: 2px !important;
  font-size: 15px;
  &:hover {
    color: $color-primary;
  }
}
.el-button--default {
  border: none;
  padding: 0;
}
.helpy_navigate {
  min-width: 18px;
}
.el-popover__title {
  font-weight: $h1-font-weight;
  word-break: break-word;
  text-align: left;
}
.helpy-tooltip--content {
  word-break: break-word;
  font-size: $h4-font-size;
}
</style>
